import { Divider } from './Components/Divider/Divider';

import * as Styled from './Breadcrumbs.styled';

import type { BreadcrumbsProps } from './Breadcrumbs.typed';
import type { LinkType } from '../../Toolkit/Button/SharedLink';

const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { breadcrumbs, goBack, inverted, className } = props;

  const linkType: LinkType = inverted ? 'INVERTED' : 'SECONDARY';

  return (
    <Styled.Container className={className}>
      <Styled.BackButton
        onClick={goBack}
        ofType={linkType}
        aria-label="Go back"
      >
        <Styled.BackIcon aria-hidden="true" />
        <Styled.BackText>Back</Styled.BackText>
      </Styled.BackButton>

      <Styled.BreadcrumbsOuterContainer>
        <Styled.BreadcrumbsInnerContainer>
          {breadcrumbs.map(({ displayName, href, ...linkProps }, index) => {
            const displayDivider = breadcrumbs.length - 1 !== index;

            return (
              <Styled.BreadcrumbAndDividerContainer key={`breadcrumb-${index}`}>
                {!href ? (
                  <Styled.Breadcrumb>
                    <Styled.BreadcrumbText inverted={inverted}>
                      {displayName}
                    </Styled.BreadcrumbText>
                  </Styled.Breadcrumb>
                ) : (
                  <Styled.BreadcrumbLink
                    data-testid={`${displayName}-breadcrumb`}
                    ofType={linkType}
                    href={href}
                    {...linkProps}
                  >
                    {displayName}
                  </Styled.BreadcrumbLink>
                )}
                {displayDivider && <Divider inverted={inverted} />}
              </Styled.BreadcrumbAndDividerContainer>
            );
          })}
        </Styled.BreadcrumbsInnerContainer>
      </Styled.BreadcrumbsOuterContainer>
    </Styled.Container>
  );
};

export { Breadcrumbs };
